module.exports = __webpack_public_path__ + "static/media/by.1f9415ab.svg";